module.exports = __webpack_public_path__ + "static/media/time.4e914f37.svg";